import { useFetchWrapper } from './fetch-wrapper'

const useIntakeFormService = () => {

  const fetchWrapper = useFetchWrapper()

  const SaveIntakeData = async (data) => {
    return fetchWrapper.post(`intakeform`, data)
  }

  return { SaveIntakeData }
}

export { useIntakeFormService };